module.exports = __webpack_public_path__ + "components/flag/static/square/sb-4d087dc188e1d70719aaa07e2bb47159.svg";